namespace TabAurous.Inventory {
    export interface SKURepricingDetailsRow {
        TransItemId?: number;
        TransId?: number;
        VoucherTypeId?: number;
        VoucherDate?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        PartyId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        RefNo?: string;
        RoutingId?: number;
        GroupId?: number;
        ItemTypeId?: number;
        ProductId?: number;
        ProductCode?: string;
        ProductName?: string;
        AttributeId?: number;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        SuperTypeId?: number;
        CollectionId?: number;
        Hsn?: string;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        Stoneweight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        CalcOnId?: number;
        UnitRate?: number;
        UnitLabour?: number;
        UnitCost?: number;
        NetAmount?: number;
        Discount?: number;
        GrossAmount?: number;
        Purity?: number;
        PureWeight?: number;
        CostMethodId?: number;
        RefTransItemId?: number;
        RefTransId?: number;
        HasBom?: boolean;
        ImageName?: string;
        Remark?: string;
        SpecialRemark?: string;
        UserDescription?: string;
        AckStatus?: number;
        DeliveryDate?: string;
        CompanyId?: number;
        BagStatus?: string;
        WstPer?: number;
        WstWt?: number;
        DiscountPer?: number;
        Lab?: string;
        DesignId?: number;
        NewSKU?: number;
        MFAmount?: number;
        MF?: number;
        BOMDetails?: SKURepricingDetailsBOMRow[];
        Parts?: number;
        ExportPieces?: number;
        Hallmark?: number;
        KaratId?: number;
        ProductSizeId?: number;
        MetalId?: number;
        MetalColorId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        StockId?: number;
    }

    export namespace SKURepricingDetailsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Inventory.SKURepricingDetails';
        export const deletePermission = 'Inventory:SKURepricing:Delete';
        export const insertPermission = 'Inventory:SKURepricing:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:SKURepricing:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            VoucherTypeId = "VoucherTypeId",
            VoucherDate = "VoucherDate",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            PartyId = "PartyId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            RefNo = "RefNo",
            RoutingId = "RoutingId",
            GroupId = "GroupId",
            ItemTypeId = "ItemTypeId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            AttributeId = "AttributeId",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            BrandId = "BrandId",
            SuperTypeId = "SuperTypeId",
            CollectionId = "CollectionId",
            Hsn = "Hsn",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            Stoneweight = "Stoneweight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            CalcOnId = "CalcOnId",
            UnitRate = "UnitRate",
            UnitLabour = "UnitLabour",
            UnitCost = "UnitCost",
            NetAmount = "NetAmount",
            Discount = "Discount",
            GrossAmount = "GrossAmount",
            Purity = "Purity",
            PureWeight = "PureWeight",
            CostMethodId = "CostMethodId",
            RefTransItemId = "RefTransItemId",
            RefTransId = "RefTransId",
            HasBom = "HasBom",
            ImageName = "ImageName",
            Remark = "Remark",
            SpecialRemark = "SpecialRemark",
            UserDescription = "UserDescription",
            AckStatus = "AckStatus",
            DeliveryDate = "DeliveryDate",
            CompanyId = "CompanyId",
            BagStatus = "BagStatus",
            WstPer = "WstPer",
            WstWt = "WstWt",
            DiscountPer = "DiscountPer",
            Lab = "Lab",
            DesignId = "DesignId",
            NewSKU = "NewSKU",
            MFAmount = "MFAmount",
            MF = "MF",
            BOMDetails = "BOMDetails",
            Parts = "Parts",
            ExportPieces = "ExportPieces",
            Hallmark = "Hallmark",
            KaratId = "KaratId",
            ProductSizeId = "ProductSizeId",
            MetalId = "MetalId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            StockId = "StockId"
        }
    }
}
